'use strict';
(function ( $ ) {
	$('nav[icons]').scrollNav();
}( jQuery ));